export default __webpack_public_path__ + "fc9ba5249878cd8f8d885c1f42b0f43d.ttf";